/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import ResizableViewer, { Format } from '@src/components/resizable.viewer'

interface Props {
  title?: string
  data: any
  onClose: () => void
}

export const CloudTrailLogDetails: React.FC<Props> = React.memo(
  (props: Props) => {
    const { data, title, onClose } = props

    React.useEffect(
      () => () => {
        onClose()
      },
      []
    )

    return (
      <>
        {data && (
          <ResizableViewer
            format={Format.json}
            data={data}
            title={title || ''}
            onCloseViewer={onClose}
          />
        )}
      </>
    )
  }
)
